import moment from "moment";

export type MonthsObject = {
    [x: string]: {
        event: {
            eventStart: string;
            eventEnd: string;
            eventLabel: string;
        };
        fields: {
            fieldName: string,
            fieldLabel: string,
            fieldType: string,
            fieldValue?: string | number
        }[];
        order: number;
    };
};

export const GetMonths = () => {
    const months: MonthsObject = {};
    const date = moment();

    let current = 0;
    let month: string;
    while (current < 12) {
        date.month(current);
        month = date.format('MMM');
        const formattedMonth: string = month.charAt(0).toUpperCase()+ month.slice(1);

        months[formattedMonth] = {
            event: {
                eventStart: formattedMonth,
                eventEnd: formattedMonth,
                eventLabel: formattedMonth
            },
            fields: [],
            order: date.month()
        }

        current++;
    }

    return months;
}